import { render, staticRenderFns } from "./AddNewsletterReclistDlg.vue?vue&type=template&id=205ed7fa&"
import script from "./AddNewsletterReclistDlg.vue?vue&type=script&lang=js&"
export * from "./AddNewsletterReclistDlg.vue?vue&type=script&lang=js&"
import style0 from "./AddNewsletterReclistDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports